export const payloadVersions = [
  {
    payloadVersion: 1,
    description: "Farm Observation for Weather",
    fields: [
      {
        name: "observation_date",
        type: "timestamp",
        description: "Date of the observation",
        default: "now()",
      },
      {
        name: "water_temperature",
        type: "number",
        description: "Water temperature in degrees Celsius",
        default: 0.0,
      },
      {
        name: "wave_height",
        type: "number",
        description: "Wave height in meters",
        default: 0.0,
      },
    ],
  },
  {
    payloadVersion: 2,
    description: "Manual growth observation",
    fields: [
      {
        name: "seaweed_length",
        type: "number",
        description: "Seaweed length in centimeters",
        default: 0.0,
      },
      {
        name: "notes",
        type: "text",
        description: "Notes about this observation",
        default: "",
      },
    ],
  },
]
